<template>
  <div>



    <b-col>
      <b-card class="products">
        <div
          v-if="workTypeLoading"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner />
        </div>
        <div v-else>
          
          <LiquorTree
            v-if="GET_ONE_BRIGADE.work_types"
            :data="GET_ONE_BRIGADE.work_types"
            :options="treeOptions"
            ref="tree"
            class="border"
          >
            <small
              class="tree-scope node"
              slot-scope="data"
            >
            <div class="d-flex justify-content-between w-100">
              <!-- @click="getData(node)" -->
              <span class="w-100">{{ data.node.text }}</span>
              <div class="d-flex">
                <b-button
                  class="ml-50"
                  variant="success"
                  size="sm"
                  @click="addProduct($event, data.node)"
                  v-b-modal.product-modal
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>

                <b-button
                  class="ml-50"
                  variant="warning"
                  size="sm"
                  @click="editProduct(data.node, $event)"
                  v-b-modal.product-modal
                >
                  <feather-icon icon="EditIcon" />
                </b-button>

                <b-button
                  class="ml-50"
                  variant="danger"
                  size="sm"
                  @click="deleteProduct(data.node)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
            </div>


            </small>
          </LiquorTree>

          <div class="py-50">
            <b-button
              size="sm"
              variant="success"
              v-b-modal.product-modal
            >
              <feather-icon icon="PlusIcon" />
              {{ $t("add") }}
            </b-button>
          </div>
        </div>
      </b-card>
    </b-col>








      <b-modal
        id="product-modal"
        :title="$t('add_product')"
        size="lg"
        :ok-title="$t('save')"
        :cancel-title="$t('cancel')"
        cancel-variant="danger"
        ok-variant="success"
        no-close-on-backdrop
        centered
        @close="onCancelOrCloseProductModal"
        @cancel="onCancelOrCloseProductModal"
        @ok="onSubmit"
      >
        <validation-observer ref="infoProduct">

          <div class="d-flex">
            <b-form-group :label="$t('title') + ' ru'" class="w-100">
              <validation-provider
                #default="{ errors }"
                :name="$t('title') + ' ru'"
                rules="required"
              >
                <b-form-input v-model="product.title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>


            <b-form-group :label="$t('title') + ' uz'" class="w-100 ml-1">
              <validation-provider
                #default="{ errors }"
                :name="$t('title') + ' uz'"
                rules="required"
              >
                <b-form-input v-model="product.title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <b-form-group :label="$t('reference.unit')">
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.unit')"
              rules="required"
            >
              <v-select
                v-model="product.unity"
                label="short_title"
                :reduce="(p) => p.id"
                :options="GET_UNITS.results"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        
        </validation-observer>
      </b-modal>






  </div>






</template>

<script>
import { BButton, BCol, BRow, BTable, BSidebar, BBadge, VBToggle, BSpinner, BCard, BFormInput, BFormGroup } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AppSearchInput from "@/components/AppSearchInput.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import pinnedWorksModal from "./modals/pinnedWorksModal.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";


import LiquorTree from 'liquor-tree'
import { getUserData } from '@/auth/utils'


export default {
  components: {
    BButton,
    BTable,
    BCol,
    BRow,
    Pagination,
    AppSearchInput,
    pinnedWorksModal,
    VuePerfectScrollbar,
    BSidebar, 
    BBadge,
    BSpinner,
    LiquorTree,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    vSelect

  },
  directives: {
    Ripple,
    'b-toggle': VBToggle
  },
  mixins: [areYouSure],
  props: {
    object: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION END ===============
      loading: false,


      productId: null,
      parent: null,
      product: {
        title: {
          ru: "",
          uz: "",
        },
        unity: '',
      },
      filter: {
        page_size: 300,
        parent: 0,
        lang: getUserData()?.language || "ru",
      },
      treeOptions: {
        propertyNames: {
          text: "label",
        },
      },
      editWorks: false,
      // ===============  PRIMARY_DATA_SECTION END ===============





      // ===============  OTHERS_SECTION END ===============
      
      // ===============  OTHERS_SECTION END ===============
    };
  },
  computed: {
    // ...mapGetters("obectsWarehouse", ["GET_WAREHOUSE_ID"]),
    ...mapGetters("brigade", ["GET_ONE_BRIGADE"]),
    ...mapGetters('brigadeWorks', ['getProduct', 'getProductList', 'GET_BRIGADE_WORKS']),
    ...mapGetters("characterUnits", ["GET_UNITS"]),
    workTypeLoading: {
      get: function () {
        return this.$store.state.brigade.workTypeLoading;
      },
      set: function (newValue) {
        this.$store.commit('brigade/SET_BRIGADE_WORK_TYPE_LOADING', newValue)
      }
    },
  },
  async mounted() {
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_UNITS({page_size: 1000})
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
  },
  methods: {
    ...mapActions('brigadeWorks', ['FETCH_PRODUCT', 'FETCH_PRODUCT_LIST', 'CREATE_BRIGADE_WORKS', 'FETCH_ALL_BRIGADE_WORKS', 'FETCH_ONE_BRIGADE_WORKS',
    'DELETE_BRIGADE_WORKS', 'UPDATE_PUT_BRIGADE_WORKS', 'UPDATE_PATCH_BRIGADE_WORKS']),
    ...mapMutations('brigadeWorks', ['SET_PRODUCT']),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),
    ...mapActions('brigade', ['FETCH_BRIGADE', 'DELETE_BRIGADE', 'FETCH_ONE_BRIGADE']),





    async refresh(){
      await this.FETCH_ONE_BRIGADE({ id: Number(this.$route.query.brigade_id) })
    },



    async getData(data) {
      try {
        if (this.productId == data.id) {
          return;
        }
        this.productId = data.id;
        this.loading = true;

        await this.FETCH_PRODUCT(data.id);

        if (
          typeof this.getProduct.title === "object" &&
          this.getProduct.title != null
        ) {
          this.product.title.ru = this.getProduct.title.ru;
          this.product.title.uz = this.getProduct.title.uz;
        }

        if (this.getProduct.body) {
          this.product.body = this.getProduct.body;
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$_errorToast();
      }
    },



    addProduct(event, node) {
      event.stopPropagation();
      this.parent = node;
    },
    onCancelOrCloseProductModal(){
      this.product.title.ru = ''
      this.product.title.uz = ''
      this.product.unity = null
      this.product.id = null
    },

    async editProduct(node, event){
      await this.FETCH_ONE_BRIGADE_WORKS({id: node.id})
      
      this.product.title.ru = this.GET_BRIGADE_WORKS.title.ru
      this.product.title.uz = this.GET_BRIGADE_WORKS.title.uz
      this.product.unity = this.GET_BRIGADE_WORKS.unity
      this.product.id = node.id

      this.editWorks = true
    },






    // ===============  DELETE_SECTION START ===============
    deleteProduct(node) {
      this.$_showAreYouSureModal().then(val => {
          if (val) {
            this.DELETE_BRIGADE_WORKS(node.id)
              .then(async () => {
                await this.refresh();
                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              });
          }
        });
    },
    // ===============  DELETE_SECTION END ===============








    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.infoProduct.validate().then(async (success) => {
        if (!success) {
          return;
        }

        try {
          this.workTypeLoading = true
          if (this.parent) {
            this.product.parent = Number(this.parent.id)
          }
          this.product.brigade = Number(this.$route.query.brigade_id)


          if(this.editWorks){
            await this.UPDATE_PUT_BRIGADE_WORKS(this.product);
          }else{
            await this.CREATE_BRIGADE_WORKS(this.product);
          }

          this.$nextTick(() => {
            this.$bvModal.hide("product-modal");
          });

          // setTimeout(() => {
          //   this.clearData();
          // }, 1000);

          await this.FETCH_ONE_BRIGADE({id: this.$route.query.brigade_id});
          this.$forceUpdate()
          this.$_okToast();

          this.product.title.ru = ''; 
          this.product.title.uz = ''; 
          this.product.unity = ''; 

          this.editWorks = false
          setTimeout(() => {
            this.workTypeLoading = false
          }, 0)
        } catch (err) {
          console.log(err)
          // this.$emit("changeProductModal", false);
          // this.$_errorToast();
        }
      });
    },











    // ===============  DELETE_SECTION START ===============

    // ===============  DELETE_SECTION END ===============








    // ===============  FILTER_SECTION START ===============

    // ===============  FILTER_SECTION END ===============









    // ===============  REFRESH_SECTION START ===============

    // ===============  REFRESH_SECTION END ===============







    // ===============  ON_SUBMIT_SECTION START ===============

    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>








<style scoped>
.scroll {
  height: 10vh;
}








.product,
.products {
    height: 80vh;
    overflow-y: auto ;
}

.product {
    background-color: #F8F8F8
}

div.it p {
    text-indent: 30px;
    text-align: justify;
}

.tree-checkbox {
    width: 20px !important;
    height: 20px !important;
}

.tree-checkbox.checked:after {
    width: 3px;
    left: 5px;
    top: -2px !important;
    height: 14px;
}

.node {
    width: 100%;
}



</style>

























